import reactFirestore from "./ReactFirestore";

const useQuery = (query) => {
  return reactFirestore.readQueries([query]);
};

export default useQuery;
